<template>
  <v-layout column>
    <v-flex class="my-2">
      {{ permissionsType === 'FOLDER' ? 'Carpetas' : 'Reportes' }}:
    </v-flex>
    <v-flex>
        <!-- style="border-radius:10px !important;" -->
      <v-data-table
        class="strategio-table-section"
        hide-headers
        hide-actions
        item-key="itemID"
        :items="items"
        :pagination.sync="pagination"
        no-data-text="No hay items"
      >
        <template slot="items" slot-scope="props">
          <!-- <tr style="background-color:#eee"> -->
          <tr style="background-color:rgba(255, 255, 255, 0)" :class="[props.expanded ? 'expanded' : '']">
            <td
              class="pl-2 pr-0"
            >
              <v-layout fill-height align-center body-2>
                <v-flex
                  layout
                  align-center
                  fill-height
                  @click="props.expanded = !props.expanded"
                  style="cursor:pointer;font-size:10px;color:gray;"
                >
                  {{ props.item.itemName }}
                </v-flex>
                <!-- <v-btn small flat color="primary">Agregar</v-btn> -->
                <v-btn
                  small depressed dark
                  class="ma-0 fill-height strategio-dialog-button"
                  :style="[
                    {'border-radius': '0px'},
                    {'width': '110px'},
                    {'background-color': permissionsType === 'FOLDER' ? '#FAB100' :  '#19BAE8'}
                  ]"
                >Agregar</v-btn>
              </v-layout>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card flat>
            <v-card-text
              :key="index"
              class="py-1"
              v-for="(item, index) in correctUsersID(props.item.usersID)"
            >
              <v-layout row wrap align-center>
                <v-flex xs12 sm12 md3>
                  <v-chip
                    label
                    small
                    :color="pickColor(getUserData(item).userType)" class="ml-0"
                    style="font-style:italic;color:white;"
                  >{{ getUserData(item).userType }}</v-chip>
                </v-flex>

                <v-flex xs12 sm12 md4>
                  <span
                    class="grey--text"
                    style="font-weight:500;font-style:italic;"
                  >{{getUserData(item).name}}</span>
                </v-flex>

                <v-flex xs12 sm12 md5>
                  <span
                    class="grey--text"
                    style="font-style:italic;"
                  >{{getUserData(item).mail}}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex text-xs-right>
      <v-pagination
        :class="['strategio-pagination-component', permissionsType === 'FOLDER' ? 'folder' : 'report']"
        :length="pages"
        v-model="pagination.page"
      ></v-pagination>
    </v-flex>
  </v-layout>
</template>

<script>
import {find, flatMap, filter} from 'lodash'

export default {
  data () {
    return {
      pagination: {
        rowsPerPage: 3
      },
      pickColor (userType) {
        switch (userType) {
          case 'ADMIN': return 'blue darken-1'
          case 'SUPERVISOR': return 'amber darken-1'
          case 'GLOBAL': return 'light-green darken-1'
          case 'NORMAL': return 'cyan darken-1'
          case 'DEMO': return 'purple darken-1'
          default: return 'grey darken-1'
        }
      }
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 1

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    getUserData (userID) {
      return find(this.users, (user) => user.userID === userID)
    },
    correctUsersID (usersID) {
      flatMap(filter(this.users, (user) => {
        return ['SUPERVISOR', 'GLOBAL'].includes(user.userType)
      }), 'userID').forEach((userID) => {
        if (!usersID.includes(userID)) usersID.push(userID)
      })

      return usersID
    }
  },
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    users: {
      type: Array,
      default () {
        return []
      }
    },
    permissionsType: {
      type: String,
      default () {
        return ''
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/folders/current-folder-permissions-tree.vue